import React, { useEffect, useState } from "react";
import { Table, Input, Tag, Col } from "antd";
import HeadingBack from "../components/common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { allApiAction } from "../Redux/common/action";

function Users() {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { userList } = useSelector((state) => ({
    userList: state?.allApi?.user_list || {},
  }));

  const listData = userList?.data || [];

  useEffect(() => {
    dispatch(
      allApiAction.getUsers({
        page: page,
        search: search,
      })
    );
  }, [page, search, dispatch]);

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  const columns = [
    {
      title: "S.No.",
      key: "serial",
      width: 80,
      render: (_, __, index) => {
        return (page - 1) * (userList?.per_page || 10) + index + 1;
      },
    },

    // User ID
    {
      title: "User ID",
      dataIndex: "id",
      key: "id",
      width: 100,
      render: (value) => value || "-",
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value) => value || "-",
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (value) => value || "-",
    },

    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      render: (value) => value || "-",
    },

    // {
    //   title: "Role",
    //   dataIndex: "role",
    //   key: "role",
    //   render: (value) => (
    //     <Tag color={value === "admin" ? "blue" : "default"}>
    //       {value || "-"}
    //     </Tag>
    //   ),
    // },

    // {
    //   title: "Status",
    //   dataIndex: "active",
    //   key: "active",
    //   render: (value) => (
    //     <Tag color={value ? "green" : "red"}>
    //       {value ? "Active" : "Inactive"}
    //     </Tag>
    //   ),
    // },

    // {
    //   title: "Email Verified",
    //   dataIndex: "email_verified_at",
    //   key: "email_verified_at",
    //   render: (value) => (
    //     <Tag color={value ? "green" : "orange"}>
    //       {value ? "Verified" : "Not Verified"}
    //     </Tag>
    //   ),
    // },

    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => {
        if (!value) return "-";

        return new Date(value).toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
  ];

  return (
    <div>
      {/* Header Bar */}
      <div className="flex">
        <div>
          <HeadingBack
            title="Users"
            subHeading={`Total ${userList?.total || 0} Users`}
          />
        </div>

        {/* Search */}
        <Col md={5} sm={5} xs={12} className="ml-5 pl-5">
          <Input
            type="text"
            autoComplete="off"
            className="form-control"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search..."
            value={search}
          />
        </Col>
      </div>

      {/* Users Table */}
      <div className="tableResponsive mt-10">
        <Table
          rowKey="id"
          dataSource={listData}
          columns={columns}
          className="table antd_table"
          pagination={{
            current: page,
            pageSize: userList?.per_page || 10,
            total: userList?.total || 0,
            onChange: (currentPage) => {
              handlePageChange(currentPage);
            },
            hideOnSinglePage: true,
          }}
        />
      </div>
    </div>
  );
}

export default Users;
